import { useState, useEffect } from "react";
import { Grid, Button } from "@mui/material";
import MonthlyPerGroup from "./MonthlyPerGroup";
import WeeklyPerGroup from "./WeeklyPerGroup";
import DailyPerGroup from "./DailyPerGroup";
import DailyDownPerGroup from "./DailyDownPerGroup";
const ReportGroupReports = ({ group }) => {
  const [selectedReport, setSelectedReport] = useState("monthly");
  return (
    <>
      <Grid
        container
        gap={1}
        size={{ xs: 12, md: 6 }}
        justifyContent={"center"}
      >
        <Button
          variant={selectedReport === "monthly" ? "contained" : "outlined"}
          onClick={() => setSelectedReport("monthly")}
        >
          Monthly
        </Button>

        <Button
          variant={selectedReport === "weekly" ? "contained" : "outlined"}
          onClick={() => setSelectedReport("weekly")}
        >
          Weekly
        </Button>

        <Button
          variant={selectedReport === "daily" ? "contained" : "outlined"}
          onClick={() => setSelectedReport("daily")}
        >
          Daily Runtime
        </Button>
        <Button
          variant={
            selectedReport === "daily-downtime" ? "contained" : "outlined"
          }
          onClick={() => setSelectedReport("daily-downtime")}
        >
          Daily Downtime
        </Button>
      </Grid>

      <div style={{ marginTop: 16 }}>
        {selectedReport === "monthly" && <MonthlyPerGroup group={group} />}
        {selectedReport === "weekly" && <WeeklyPerGroup group={group} />}
        {selectedReport === "daily" && <DailyPerGroup group={group} />}
        {selectedReport === "daily-downtime" && (
          <DailyDownPerGroup group={group} />
        )}
      </div>
    </>
  );
};

export default ReportGroupReports;
